import { useState, useEffect } from "react";
import styled from "styled-components";
import BookService from "../../services/BookService";
import BookCardMini from "./BookCardMini";

const Section = styled.div`
  width: 100%;
  margin-top: 1.5rem;
  border-top: 1px solid ${({ theme }) => theme.colors.lineColor}44;
  padding-top: 1rem;
`;

const SectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 0.75rem;
`;

const ScrollRow = styled.div`
  display: flex;
  gap: 0.75rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.lineColor}44 transparent;
`;

function SimilarBooks({ bookId, user }) {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    if (!bookId) return;
    BookService.getSimilarBooks(bookId, 8).then(setBooks).catch(() => {});
  }, [bookId]);

  if (books.length === 0) return null;

  return (
    <Section>
      <SectionTitle>Slične knjige</SectionTitle>
      <ScrollRow>
        {books.map(b => (
          <BookCardMini key={b.id} book={b} user={user} />
        ))}
      </ScrollRow>
    </Section>
  );
}

export default SimilarBooks;
